import { v4 as uuidv4 } from 'uuid';
import { useDomainRepository } from "hooks";
import BusinessLogicException from "exceptions/BusinessLogicException";
import { RequestQueryMapper } from 'util/request-query-mapper';
import { getTransactionHistory } from "features/transactions/api";
import {
    makeState,
    Repository as HistoryRepository,
    type HistoryRepositoryState,
    type HistoryRecord
} from "./repository";
import { reducer, RepositoryActionType, useRequest } from "../Repository";

export const useHistory = () => {
    const request = useRequest();

    const repository = useDomainRepository<
        HistoryRepositoryState,
        RepositoryActionType
    >({
        reducer: reducer(makeState),
        initializerArg: makeState(),
        factory: (state, dispatch) => new HistoryRepository(
            state,
            dispatch,
            async (globalSearchQueryParams?: string) => {
                const { data: response } = await request((searchQueryParams?: string) => getTransactionHistory(
                    RequestQueryMapper.from(globalSearchQueryParams)
                        .concat(`${searchQueryParams}`)
                        .toString()
                ));

                const { data = [], highlights } = response ?? {};

                return data.map((item: HistoryRecord, index: number) => ({
                    ...highlights[index],
                    ...item,
                    _id: uuidv4()
                }));
            }
        )
    });

    if (repository instanceof HistoryRepository) {
        return repository;
    }

    throw new BusinessLogicException('Repository is not an instance of HistoryRepository', {
        repository
    });
};

export default useHistory;
